const state = {
  g1PaperList: [],
  otherPaperList: [
    {
      needKey: 'needCcFreeInsp',
      needName: '免憑商檢放行切結書',
      needCtxKey: 'ccFreeInsps',
      needCfmKey: 'ccFreeInspsCfm',
    },
    {
      needKey: 'needCcNccSelf',
      needName: 'NCC自用切結書',
      needCtxKey: 'ccNccSelfs',
      needCfmKey: 'ccNccSelfsCfm',
    },
    {
      needKey: 'needCcPrtlRel',
      needName: '部分放行申請書',
      needCtxKey: 'ccPrtlRels',
      needCfmKey: 'ccPrtlRelsCfm',
    },
    {
      needKey: 'needCcWaiver',
      needName: '放棄書',
      needCtxKey: 'ccWaivers',
      needCfmKey: 'ccWaiversCfm',
    },
    {
      needKey: 'needCcBevRel',
      needName: '押款放行申請書+承諾書',
      // needName: '電動車押款放行申請書2聯、承諾書',
      needCtxKey: 'ccBevRels',
      needCfmKey: 'ccBevRelsCfm',
    },
  ],
}

const getters = {
}

const mutations = {
  setG1PaperList (state, v) {
    state.g1PaperList = v
  }
}

const actions = {
  presets ({ state, commit, rootState }, params) {
    return rootState.axios.get('/cc/v1frontend/goodscc/presets', {params})
  },
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/cc/v1frontend/goodscc/search', {params})
  },
  searchX3G1 ({ state, commit, rootState }, params) {
    return rootState.axios.get('/cc/v1frontend/goodscc/search-x3g1', {params}).then(res => {
      if (!res.data.error) {
        res.data.list = res.data.list.map(item => {
          if (!item.gccExtras) {
            item.gccExtras = {}
          }
          if (!item.gccExtras.papers) {
            item.gccExtras.papers = {}
          }
          const papers = item.gccExtras.papers
          item.buyLinks = papers[8] || ''
          // item.hasPaper = Object.keys(item.gccExtras.papers).length > 0
          item.hasPaper = papers[1] && papers[1024]
          item.otherPaperList = state.otherPaperList.filter(paper => {
            return item.synchro.extras[paper.needKey] === '1'
          })
          item.hasPaper = item.hasPaper && !item.otherPaperList.find(paper => {
            return !item.synchro.extras[paper.needCfmKey] || item.synchro.extras[paper.needCfmKey][0] !== 'ok'
          })
          item.ccNames = ''
          if (item.synchro && item.synchro.sid) {
            if (item.synchro.extras && item.synchro.extras.declCargoes) {
              item.ccNames = Array.from(new Set(item.synchro.extras.declCargoes.map(item => item.ccName))).join(',')
            }

            item.isCompany = /^(\d{8})$/.test(item.synchro.idNum)
          }
          item.pending = false
          if (item.hasPaper) {
            if (!item.gccExtras.paperDownloadAt) {
              item.pending = true
            }
            if (!item.gccExtras.papers[2048]) {
              item.pending = true
            }
          }
          return item
        })
        commit('setG1PaperList', res.data.list)
      }
      return res
    })
  },
  searchX3G1Notkkren ({ state, commit, rootState }, params) {
    return rootState.axios.get('/cc/v1frontend/goodscc/search-x3g1-notkkren', {params})
  },
  searchCheckReport ({ state, commit, rootState }, params) {
    return rootState.axios.get('/cc/v1frontend/goodscc/search-check-report', {params})
  },
  /*
  更新需要索取的報關資料
POST /cc/v1frontend/goodscc/update
gccNeedPaper: 索取报关资料，值为所索取资料值相加，如：1+2+4=7、2+4=6
  */
  update ({ state, commit, rootState }, params) {
    return rootState.axios.post('/cc/v1frontend/goodscc/update', params)
  },
  /*
  更新、上傳报关资料
POST /cc/v1frontend/goodscc/upload-papers
mailNo
hawbNo
papers 报关资料对象数据
{
    "hawbNo": "710RG631",
    "papers[1][]": fs.createReadStream("..."),
    "papers[1][]": fs.createReadStream("..."),
    "papers[1][]": fs.createReadStream("..."),
    "papers[2][]": fs.createReadStream("..."),
    "papers[8][]": "www.xxx.com", // 不是文件类型则填写相应字符信息
    "papers[8][]": "www.zzz.com",
}
  */
  uploadPapers ({ state, commit, rootState }, params) {
    return rootState.axios.post('/cc/v1frontend/goodscc/upload-papers', params)
  },
  /**
   *  更新報關資料下載時間
    {
      "hawbNo": "710EW690"
    }
   * @param {*} param0
   * @param {*} params
   * @returns
   */
  updateHawbDownloadAt ({ state, commit, rootState }, params) {
    return rootState.axios.post('/cc/v1frontend/goodscc/update-hawb-download-at', params)
  },
  delete ({ state, commit, rootState }, params) {
    return rootState.axios.post('/cc/v1frontend/goodscc/delete', params)
  },
  batchCreate ({ state, commit, rootState }, params) {
    return rootState.axios.post('/cc/v1frontend/goodscc/batch-create', params)
  },
  updateHawbDeclFile ({ state, commit, rootState }, params) {
    return rootState.axios.post('/cc/v1frontend/goodscc/update-hawb-decl-file', params, {
      headers: {'Content-Type': 'multipart/form-data'},
      noShowError: true,
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/cc/goodscc.js